<template>
   <div class="checkout-form-group__fields">
    <div class="delivery-items">
        <button
            v-for="item in deliveryItems"
            @click="selectItem(item)"
            :key="'delivery_'+item.id"
            :class="{ 'delivery-item--selected': order.delivery == item.id }"
            class="delivery-items__item delivery-item">

            <span
                :class="{ 'delivery-item__check--checked': order.delivery == item.id }"
                class="delivery-item__check">
                <i
                    v-if="order.delivery == item.id"
                    class="fa fa-circle-check delivery-item__check-icon"></i>
                <i v-else class="delivery-item__empty-check-icon"></i>
            </span>
            <span class="delivery-item__content">
                <span class="delivery-item__header">
                    <span class="delivery-item__name">
                        {{ item.name }}
                    </span>
                    <span class="delivery-item__price">
                        <span v-if="item.calculated_price">{{ item.calculated_price }} руб.</span>
                        <span v-else>Без доплат</span>
                    </span>
                </span>
                <span class="delivery-item__about">
                    {{ item.help_text }}
                </span>
            </span>
        </button>
    </div>
   </div>
</template>


<script>
import axios from 'axios';


export default {

  name: 'CheckoutDeliveryForm',
  
  props: {
    order: {
      type: Object,
      default: null
    },
    errors: {
      type: Object,
      default: {}
    }
  },

  components: {

  },

  data() {
    return {
        deliveryItems: null
    }
  },

  mounted() {
    this.getDeliveryItems()
  },

  methods: {
    getDeliveryItems () {
        axios.get(`/checkout/api/deliveries/`).then(
            response => {
                this.deliveryItems = response.data
            }
        )
    },

    selectItem (item) {
      this.order.delivery = item.delivery
      this.$emit('on-select', item)
    }
  },

}
</script>


<style lang="scss"></style>
